export const CTLayerItemType = 'CloudTwin';
